import { useCallback, useEffect, useRef } from "react";

const MAX_HEIGHT_PX = 160;

export const useAutoResizeTextarea = (value: string) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  const mountedRef = useRef(false);

  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    // Skip first resize — scrollHeight can carry a stale value from a
    // previous mount in the same DOM slot (keyboard-reopen regression).
    if (!mountedRef.current) {
      mountedRef.current = true;
      el.style.height = "";
      return;
    }

    el.style.height = "auto";
    const next = Math.min(el.scrollHeight, MAX_HEIGHT_PX);
    if (next > 0) {
      el.style.height = `${next}px`;
    }
  }, []);

  useEffect(() => {
    resize();
  }, [value, resize]);

  return ref;
};
